/** @format */

import React, { Component } from 'react';
import { Modal, Header, Form, Icon } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('RequestsStore')
@observer
class RequestNoteModal extends Component {
  render() {
    let { RequestsStore } = this.props;
    return (
      <Modal open={RequestsStore.requestsParams.requestNoteModal}>
        <Modal.Content>
          <Header className="modal-header" as="h3">
            Note Richiesta
          </Header>
          <div className="header-spacer"></div>
          <Form
            className="modal-form"
            size="small"
            onSubmit={() => RequestsStore.toggleRequestNoteModal()}
          >
            <Form.Group widths="equal">
              <Form.TextArea
                autoComplete="off"
                onChange={(e, input) =>
                  RequestsStore.editRequestNote(input.value)
                }
                name="notes"
                value={RequestsStore.currentRequest.data.note}
                label="Note"
                placeholder="Note"
              ></Form.TextArea>
            </Form.Group>
            <Form.Button type="submit" color="green" fluid>
              <Icon name="save" />
              Salva
            </Form.Button>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export default RequestNoteModal;
